enum AxleLocation {
    FRONT = 'FRONT',
    REAR = 'REAR',
    SPARE = 'SPARE'
}

export default AxleLocation;